import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { IconButton, TableRow } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';

const BankAccountsRow = ({ row, translateBankAccountType, onEdit }) => {
  const { t } = useTranslation();

  const handleEditClick = useCallback(() => {
    if (onEdit) {
      onEdit(row);
    }
  }, [onEdit, row]);

  return (
    <TableRow hover>
      <TableCell align="center">
        {translateBankAccountType(row.bankAccountType) || t('COMMON.NO_DATA')}
      </TableCell>
      <TableCell align="center">
        {row.bankName || t('COMMON.NO_DATA')}
      </TableCell>
      <TableCell align="center">
        {row.bankAccountNumber || t('COMMON.NO_DATA')}
      </TableCell>
      <TableCell align="center">
        <IconButton
          aria-label={t('COMMON.EDIT')}
          size="small"
          onClick={handleEditClick}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

BankAccountsRow.propTypes = {
  row: PropTypes.object.isRequired,
  translateBankAccountType: PropTypes.func.isRequired,
  onEdit: PropTypes.func
};

export default BankAccountsRow;
